import { isEmpty, pathOr } from 'ramda';
import { getPageName } from './getPageName';
import { getAnalyticsPath } from './getAnalyticsPath';
import { JOINT_TYPE, SOLE_TYPE, NTB_JOURNEY, PRE_ASSESSED_JOURNEY } from 'constants/general';
import { getDeviceContext } from 'utils/deviceContext';
import { getError } from './getError';

const { isNative } = getDeviceContext();

const inject = () => {
  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script');
      script.src = getAnalyticsPath();
      script.async = true;
      document.head.appendChild(script);
      resolve('Analytics: added');
    } catch (error) {
      reject(`Analytics: ${error}`);
    }
  });
};

const send = () => (dispatch, getState) => {
  const {
    caseDetails: { caseId },
    config: {
      bankId,
      brandId,
      isJoint,
      isSecondaryApplicant,
      journey,
      origin: storedOrigin,
      loanType
    },
    customer,
    error
  } = getState();

  let origin = storedOrigin && bankId === 'DYB' ? 'B Web' : `${bankId} Web`;
  if (isNative) {
    origin = 'Mob';
  } else if (!isNative && !storedOrigin) {
    origin = 'Brochureware';
  }

  const journeyType =
    journey === NTB_JOURNEY
      ? 'new-to-bank'
      : journey === PRE_ASSESSED_JOURNEY
      ? 'existing-pre-assessed'
      : 'existing-non-assessed';

  const dataLayer = {
    appInfo: {
      applicant: isJoint && isSecondaryApplicant ? 'secondary applicant' : '',
      application_caseId: caseId ? caseId : '',
      applicationType: journeyType,
      brandName: brandId,
      customerNumber: pathOr('', ['customerInfo', 'customer_info'], customer),
      errors: getError(error),
      loanType: !isEmpty(loanType) ? loanType : isJoint ? JOINT_TYPE : SOLE_TYPE,
      origin,
      pageName: getPageName(window.location.pathname),
      productName: 'PERSONAL LOANS',
      productType: '',
      relationship: journeyType
    }
  };

  window._dataLayer = {
    ...(window._dataLayer && { ...window._dataLayer }),
    ...dataLayer
  };
  dispatch({
    type: 'analytics/update',
    payload: window._dataLayer
  });
};

const sendCustInfoError = (errorCode, errorMessage) => {
  const dataLayerCustError = {
    errorCode: errorCode,
    errorMessage: errorMessage,
    currentPage: window.location.pathname
  };
  window._dataLayer.appInfo.errors = {
    ...dataLayerCustError
  };
};

export const Analytics = {
  inject,
  send,
  sendCustInfoError
};
